import { Component } from '@angular/core';
import {TranslationService} from "./translation.service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'Nota-Q';

  constructor(public lang: TranslationService) {
  }
}
